"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AndroidMessageListener = (function () {
    function AndroidMessageListener(window) {
        var _this = this;
        this.window = window;
        this.commandListeners = new Map();
        this.onMessageReceived = function (type, data) {
            var listener = _this.commandListeners.get(type);
            if (listener) {
                listener(data);
            }
        };
        this.window.androidCallback = this.onMessageReceived;
        this.android = window.Android;
        this.android.setCallback('window.androidCallback');
    }
    AndroidMessageListener.getInstance = function (context) {
        if (!this.instance) {
            this.instance = new AndroidMessageListener(context);
        }
        return this.instance;
    };
    AndroidMessageListener.prototype.registerMessageListener = function (androidCommand, listener) {
        this.commandListeners.set(androidCommand, listener);
    };
    AndroidMessageListener.prototype.unregisterMessageListener = function (androidCommand) {
        this.commandListeners.delete(androidCommand);
    };
    return AndroidMessageListener;
}());
exports.AndroidMessageListener = AndroidMessageListener;
